import { Injectable, signal } from '@angular/core';
import { UserProfile } from '../models/auth.model';

const ACCESS_TOKEN_KEY = 'admin_access_token';
const REFRESH_TOKEN_KEY = 'admin_refresh_token';
const USER_PROFILE_KEY = 'admin_user_profile';

@Injectable({ providedIn: 'root' })
export class TokenStorageService {
  readonly currentUser = signal<UserProfile | null>(this.loadUserFromStorage());

  getAccessToken(): string | null {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  }

  getRefreshToken(): string | null {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  }

  setTokens(accessToken: string, refreshToken: string): void {
    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  }

  setUser(user: UserProfile): void {
    localStorage.setItem(USER_PROFILE_KEY, JSON.stringify(user));
    this.currentUser.set(user);
  }

  clear(): void {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(USER_PROFILE_KEY);
    this.currentUser.set(null);
  }

  isLoggedIn(): boolean {
    return !!this.getAccessToken();
  }

  /** علاوه بر لاگین بودن، باید نقش Admin هم در پروفایل کش‌شده تایید شده باشد */
  isAdminLoggedIn(): boolean {
    return this.isLoggedIn() && this.currentUser()?.isAdmin === true;
  }

  private loadUserFromStorage(): UserProfile | null {
    const raw = localStorage.getItem(USER_PROFILE_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as UserProfile;
    } catch {
      return null;
    }
  }
}
